module.exports = __webpack_public_path__ + "fonts/Graphik-ThinItalic-Web.2a47647.woff";